import { Base } from '@studiometa/js-toolkit';
import { trackClickAddFavorite } from '../utils/datalayer.js';

/**
 * @typedef {{
 *   $refs: {
 *     icon: HTMLElement;
 *   },
 *   $options: {
 *     postId: string;
 *     offerName: string;
 *     offerUrl: string;
 *   }
 * }} WishlistProps
 */

/**
 * Wishlist component.
 * @augments {Base<WishlistProps>}
 */
export default class Wishlist extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Wishlist',
    options: {
      postId: String,
      offerName: String,
      offerUrl: String,
    },
    refs: ['icon'],
    emits: ['event'],
  };

  /**
   * Toggle the wishlist state of the item on click.
   * @returns {void}
   */
  onClick() {
    // Use the same class the server applies to the filled state
    // (see wishlist-btn.twig) so both stay in sync.
    this.$refs.icon.classList.toggle('*:fill-white');

    fetch('/wp/wp-admin/admin-ajax.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `action=handle_wishlist&post_id=${this.$options.postId}&security=custom_nonce`,
    })
      .then((response) => response.json())
      .then((response) => {
        this.$emit('event', response.data);

        if (response.added && this.$options.offerName) {
          trackClickAddFavorite(this.$options.offerName, this.$options.offerUrl);
        }

        // Inside a wishlist listing (e.g. the dashboard), removing an item
        // should also remove its card from the slider.
        if (!response.added && this.$el.closest('[data-wishlist-removable]')) {
          this.removeFromSlider();
        }
      });
  }

  /**
   * Remove the enclosing slider item and let the slider recompute its bounds.
   * @returns {void}
   */
  removeFromSlider() {
    const item = this.$el.closest('[data-component~="SliderItem"]');
    if (!item) {
      return;
    }

    const slider = item.closest('[data-component~="Slider"]');
    item.remove();
    slider?.dispatchEvent(new CustomEvent('wishlist-item-removed'));
  }
}
